'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeSection = function (_React$Component) {
    _inherits(PromizeSection, _React$Component);

    function PromizeSection(props) {
        _classCallCheck(this, PromizeSection);

        var _this = _possibleConstructorReturn(this, (PromizeSection.__proto__ || Object.getPrototypeOf(PromizeSection)).call(this, props));

        _this.pzActiveSectionHandler = function (sectionId) {
            var _this$props = _this.props,
                pzActiveTab = _this$props.pzActiveTab,
                pzCustomizer = _this$props.pzCustomizer,
                pzCurrentView = _this$props.pzCurrentView;

            var pzChangeView = pzCurrentView;
            if (pzActiveTab[sectionId] && pzCustomizer.tabs[pzActiveTab[sectionId]] && pzCustomizer.tabs[pzActiveTab[sectionId]].default_view) {
                pzChangeView = pzCustomizer.tabs[pzActiveTab[sectionId]].default_view;
            }
            _this.props.HomeComponent.setState({ pzActiveSection: parseInt(sectionId), pzCurrentView: pzChangeView }, function () {
                /* if (pzCurrentView != pzChangeView) {
                    this.props.HomeComponent.pzReloadCanvasObjects()
                } */

                _this.props.HomeComponent.pzTurnModel('outside', true);
            });
        };

        return _this;
    }

    _createClass(PromizeSection, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var promizeThreeDObj = this.props.promizeThreeDObj;
            document.getElementById('pz-left-container').appendChild(document.getElementById('three-container'));
            if (document.getElementById('pz-image-full-screen')) {
                document.getElementById('pz-image-full-screen').appendChild(document.getElementById('pz-full-screen'));
            }
            var _2dRootElements = {
                canvasContainer: document.querySelector('#pz-overlay-container-canvas'),
                thumbContainer: document.querySelector('#pz-cp-thumb')
            };

            var promize2D = new promizeThreeDObj.TwoD(_2dRootElements);
            this.props.HomeComponent.setState({
                promizeTwoDObj: promize2D
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var sections = this.props.pzCustomizer.sections ? this.props.pzCustomizer.sections : {};
            return React.createElement(
                React.Fragment,
                null,
                Object.keys(this.props.pzCustomizer.sections).length > 0 && React.createElement(PZSection, _extends({ pzSections: sections, pzSection: this }, this.props))
            );
        }
    }]);

    return PromizeSection;
}(React.Component);